import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FlexBox from "../../components/FlexBox";
import { useNavigate } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import LightTextField from "../../components/LightTextField";
import { grossIncomeLength } from "../../common/common";
import CircularProgress from "@mui/material/CircularProgress";
import {
  userKycVerifyDetails,
  createInvestorMutualFund,
  createInvestmentMutualFund,
} from "../../redux/actions/KYCAction";
import * as Models from "../../models";
import { getUserInfo } from "../../redux/actions/UserAction";
import { aadharLength } from "../../common/common";
import {
  OCCUPATION_PROOF_TYPE_LIST,
  ADDRESS_PROOF_TYPE_LIST,
  WEALTH_TYPE_LIST,
} from "../../constants/constant";
import { H3, Small, H4,} from "../../components/Typography";
import { FC } from "react";
import { load, save } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import { toast } from "react-hot-toast";

interface SecondStepProps {
  onPress: any;
  onBackPress: any;
  complice: boolean;
}
type FormValues = {
  aadhar: string;
  fathers_name: string;
  mothers_name: string;
  country: string;
  gross_income: string;
  proof_number: string;
  proof_expiry_date: string;
  proof_issue_date: string;
  spouse_name: string;
};

type FormErrors = {
  aadhar?: string;
  fathers_name?: string;
  mothers_name?: string;
  country?: string;
  gross_income?: string;
  proof_number?: string;
  proof_expiry_date?: string;
  proof_issue_date?: string;
  spouse_name?: string;
};

const KYCSecondStep: FC<SecondStepProps> = ({
  onPress,
  onBackPress,
  complice,
}) => {
  const [formValues, setFormValues] = React.useState<FormValues>({
    aadhar: "",
    fathers_name: "",
    mothers_name: "",
    country: "",
    gross_income: "",
    proof_number: "",
    proof_expiry_date: "",
    proof_issue_date: "",
    spouse_name: "",
  });
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [radioValueResidence, setRadioValueResidence] = useState(false);
  const [radioValuePolitically, setRadioValuePolitically] = useState(false);
  const [radioValueRelatedPolitically, setRadioValueRealatedPolitically] =
    useState(false);
  const [userInfo, setUserInfo] = useState<any>();
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [maritalStatus, setMaritialStatus] = useState("");
  const [occupationType, setOccupationType] = useState("")
  const [sourceWealth, setSourceWealth] = useState("");
  const [complicePAN, setComplicePAN] = useState<boolean>(complice);
  const [residentalStatus, setResidentalStatus] = useState(
    "RESIDENT INDIVIDUAL"
  );
  const [isInvestmentRequired, setIsInvestmentRequired] = useState(true);
  const [proofType, setAddressProoftype] = useState("");
  const minissueDate = new Date(+new Date() - 86400000);
  const maxissuesdate = new Date().toISOString().slice(0, 10);
  const maxexpiryDate = new Date(+new Date() + 86400000);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Add one day to today's date
  const minexpiryDate = tomorrow.toISOString().slice(0, 10); // Set the minimum date to tomorrow

  useEffect(() => {
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    setUserInfo(finalUser);
    getUserInfomation(finalUser);
    setOccupationType(finalUser?.occupation_type ?? "");
    setSourceWealth(finalUser?.wealth_source ?? "");
    setAddressProoftype(finalUser?.proof_type ?? "");
    setMaritialStatus(
      finalUser?.marital_status === "MARRIED" ? "MARRIED" : "UNMARRIED"
    );
    setRadioValueResidence(Boolean(finalUser?.residence_ooi));
    setRadioValuePolitically(Boolean(finalUser?.politically_exposed));
    setRadioValueRealatedPolitically(Boolean(finalUser?.politically_exposed));
    setIsInvestmentRequired(finalUser?.investment_acc_id);
    if (finalUser.kyc_verified === true) {
      setComplicePAN(true);
    }
  }, []);
  const getUserInfomation = async (userDetails: any) => {
    let token = load("token");
    const req: Models.GETUSER_INFO_REQUEST = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        await save("userData", JSON.stringify(response?.data[0]));
        setFormValues(response?.data[0]);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    if (name === "gross_income" || name === "aadhar") {
      // Remove non-numeric characters from the input value
      const numericValue = value.replace(/\D/g, "");
      setFormValues({ ...formValues, [name]: numericValue });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
    setFormErrors({ ...formErrors, [name]: "" });
  }

  const isNumeric = (v: any) => {
    return !isNaN(v - parseFloat(v));
  };
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const newErrors: FormErrors = {};
    const regAadhar =
      /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
    const drivingReg =
      /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;
    const voterIdReg = /^([a-zA-Z]){3}([0-9]){7}?$/;
    const nameReg = /^[a-zA-Z \\s]+$/;
    if (!formValues.aadhar) {
      newErrors.aadhar = "Aadhaar number is required";
    }
    if (formValues.aadhar?.length !== 12) {
      newErrors.aadhar = "Please enter a valid adhaar number";
    }
    if (!regAadhar.test(formValues.aadhar)) {
      newErrors.aadhar = "Please enter a valid adhaar number.";
    }
    if (!formValues.fathers_name) {
      newErrors.fathers_name = "Father name is required.";
    }
    if (formValues.fathers_name?.length < 3) {
      newErrors.fathers_name = "Father name should be more then 3 characters";
    }
    if (!nameReg?.test(formValues.fathers_name)) {
      newErrors.fathers_name = "Special character not allowed in fatherName";
    }
    if (!formValues.mothers_name) {
      newErrors.mothers_name = "Mother name is required.";
    }
    if (formValues.mothers_name?.length < 3) {
      newErrors.mothers_name = "Mother name should be more then 3 characters";
    }
    if (!nameReg?.test(formValues.mothers_name)) {
      newErrors.mothers_name = "Special character not allowed in motherName";
    }
    if (maritalStatus === "Married" && !nameReg?.test(formValues.spouse_name)) {
      newErrors.spouse_name = "Special character not allowed in spouseName";
    }
    if (maritalStatus === "Married" && formValues.spouse_name?.length < 3) {
      newErrors.spouse_name = "Spouse name should be more then 3 characters";
    }
    if (!isNumeric(formValues.gross_income)) {
      newErrors.spouse_name = "Gross Income should be in proper format";
    }
    if (!formValues.country) {
      newErrors.country = "Country name is required.";
    }
    if (!formValues.gross_income) {
      newErrors.gross_income = "Gross income is required.";
    }
    if (!formValues.proof_number) {
      newErrors.proof_number = "Proof Number is required.";
    }
    if (proofType === "VOTER_ID" && !voterIdReg.test(formValues.proof_number)) {
      newErrors.proof_number = "Please enter a valid VOTER ID number!";
    }
    if (
      proofType === "driving_licence" &&
      !drivingReg.test(formValues.proof_number)
    ) {
      newErrors.proof_number = "Please enter a valid Driving number!";
    }
    if (
      !formValues.proof_issue_date ||
      formValues.proof_issue_date === "Invalid date"
    ) {
      newErrors.proof_issue_date = "Please select a proof issue date";
    }
    if (proofType !== "VOTER_ID" && !formValues.proof_expiry_date) {
      newErrors.proof_expiry_date = "Please select a proof expiry date";
    }

    if (
      proofType !== "VOTER_ID" &&
      formValues.proof_expiry_date === "Invalid date"
    ) {
      newErrors.proof_expiry_date = "Please select a proof expiry date";
    }

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      userMFVerifyDetails();
    }
  }
  const userMFVerifyDetails = async () => {
    let token = load("token");

    const GrossIncome = formValues.gross_income.replace(/\s+/g, " ").trim();
    const Aadhaar = formValues.aadhar.replace(/\s+/g, " ").trim();
    const FatherName = formValues.fathers_name.replace(/\s+/g, " ").trim();
    const MotherName = formValues.mothers_name.replace(/\s+/g, " ").trim();
    const ProofNumber = formValues.proof_number.replace(/\s+/g, " ").trim();

    const req: Models.MFKYCDetailVerifyRequest = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
      country: "IN",
      wealth_source: sourceWealth,
      occupation: occupationType,
      gross_income: GrossIncome,
      aadhar_number: Aadhaar,
      marital_status: maritalStatus,
      residential_status: "RESIDENT_INDIVIDUAL",
      fathers_name: FatherName,
      mothers_name: MotherName,
      residence_ooi: radioValueResidence,
      politically_exposed: radioValuePolitically,
      relative_to_politician: radioValueRelatedPolitically,
      spouse_name: formValues.spouse_name,
      proof_type: proofType,
      proof_number: ProofNumber,
      proof_issue_date: formValues.proof_issue_date,
      proof_expiry_date:
        proofType === "VOTER_ID" ? "2100-09-01" : formValues.proof_expiry_date,
    };
    dispatch(userKycVerifyDetails(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Invalid Value For marital_status") {
          toast.error("Invalid Value For marital status");
          return;
        }
        if (response.error) {
          toast.error("The Form must be Filled Completely with valid data");
          return;
        }
        onPress(formValues);
        await getUserInfomation(userInfo);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  function handleSubmitForComplice(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const newErrors: FormErrors = {};
    const regAadhar =
      /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
    const nameReg = /^[a-zA-Z \\s]+$/;
    if (!formValues.aadhar) {
      newErrors.aadhar = "Aadhaar number is required";
    }
    if (formValues.aadhar?.length !== 12) {
      newErrors.aadhar = "Please enter a valid adhaar number";
    }
    if (!regAadhar.test(formValues.aadhar)) {
      newErrors.aadhar = "Please enter a valid adhaar number.";
    }
    if (!formValues.fathers_name) {
      newErrors.fathers_name = "Father name is required.";
    }
    if (formValues.fathers_name?.length < 3) {
      newErrors.fathers_name = "Father name should be more then 3 characters";
    }
    if (!nameReg?.test(formValues.fathers_name)) {
      newErrors.fathers_name = "Special character not allowed in fatherName";
    }
    if (!formValues.mothers_name) {
      newErrors.mothers_name = "Mother name is required.";
    }
    if (formValues.mothers_name?.length < 3) {
      newErrors.mothers_name = "Mother name should be more then 3 characters";
    }
    if (!nameReg?.test(formValues.mothers_name)) {
      newErrors.mothers_name = "Special character not allowed in motherName";
    }
    if (maritalStatus === "Married" && !nameReg?.test(formValues.spouse_name)) {
      newErrors.spouse_name = "Special character not allowed in spouseName";
    }
    if (maritalStatus === "Married" && formValues.spouse_name?.length < 3) {
      newErrors.spouse_name = "Spouse name should be more then 3 characters";
    }
    if (!isNumeric(formValues.gross_income)) {
      newErrors.spouse_name = "Gross Income should be in proper format";
    }
    if (!formValues.country) {
      newErrors.country = "Country name is required.";
    }
    if (!formValues.gross_income) {
      newErrors.gross_income = "Gross income is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      userMFVerifyDetailsForComplice();
    }
  }

  const userMFVerifyDetailsForComplice = async () => {
    let token = load("token");
    const GrossIncome = formValues.gross_income.replace(/\s+/g, " ").trim();
    const Aadhaar = formValues.aadhar.replace(/\s+/g, " ").trim();
    const FatherName = formValues.fathers_name.replace(/\s+/g, " ").trim();
    const MotherName = formValues.mothers_name.replace(/\s+/g, " ").trim();

    const req: Models.MFKYCDetailVerifyRequestForComplice = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
      country: "IN",
      wealth_source: sourceWealth,
      occupation: occupationType,
      gross_income: GrossIncome,
      aadhar_number: Aadhaar,
      marital_status: maritalStatus,
      residential_status: "RESIDENT_INDIVIDUAL",
      fathers_name: FatherName,
      mothers_name: MotherName,
      residence_ooi: radioValueResidence,
      politically_exposed: radioValuePolitically,
      relative_to_politician: radioValueRelatedPolitically,
      spouse_name: formValues.spouse_name,
    };
    dispatch(userKycVerifyDetails(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Invalid Value For marital_status") {
          toast.error("Invalid Value For marital status");
          return;
        }
        if (response.error) {
          toast.error("The Form must be Filled Completely with valid data");
          return;
        }
        await getUserInfoComplice();
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getUserInfoComplice = async () => {
    let token = load("token");
    const req: Models.GETUSER_INFO_REQUEST = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        await save("userData", JSON.stringify(response?.data[0]));
        setFormValues(response?.data[0]);
        if (!isInvestmentRequired) {
          await createInvestor();
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const createInvestor = async () => {
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
    };

    dispatch(createInvestorMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error) {
          toast.error(
            "Not able to create Investor account, please try after sometimes"
          );
          setLoading(false);
          return;
        }
        await createInvestment();
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createInvestment = async () => {
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
    };

    dispatch(createInvestmentMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error) {
          toast.error(
            "Not able to create Investment account, please try after sometimes"
          );
          setLoading(false);
          return;
        }
        setLoading(false);
        navigate("/dashboard");
      })
      .catch((error: any) => {
        console.log("Investor error:", error);
        setLoading(false);
      });
  };

  const handleMaritalStatus = (event: SelectChangeEvent) => {
    setMaritialStatus(event.target.value);
  };
  const handleOccupationType = (event: SelectChangeEvent) => {
    setOccupationType(event.target.value);
  };
  const handleSourceWealth = (event: SelectChangeEvent) => {
    setSourceWealth(event.target.value);
  };

  const handleAddressProoftype = (event: SelectChangeEvent) => {
    setAddressProoftype(event.target.value);
  };

  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioValueResidence(event.target.value === "true");
  };

  const handleChangeradioValuePolitically = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRadioValuePolitically(event.target.value === "true");
  };

  const handleradioValueRelatedPolitically = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRadioValueRealatedPolitically(event.target.value === "true");
  };

  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <form onSubmit={complicePAN ? handleSubmitForComplice : handleSubmit}>
          <H3 sx={headingText}>Personal Details</H3>
          <LightTextField
            name="aadhar"
            label="Aadhaar Number"
            inputProps={{
              maxLength: aadharLength,
            }}
            sx={textInputStyles}
            value={formValues.aadhar}
            error={!!formErrors.aadhar}
            helperText={formErrors.aadhar}
            onChange={handleChange}
          />
          <LightTextField
            name="fathers_name"
            label="Father’s Name"
            sx={textInputStyles}
            value={formValues.fathers_name}
            error={!!formErrors.fathers_name}
            helperText={formErrors.fathers_name}
            onChange={handleChange}
          />
          <LightTextField
            name="mothers_name"
            label="Mother’s Name"
            sx={textInputStyles}
            value={formValues.mothers_name}
            error={!!formErrors.mothers_name}
            helperText={formErrors.mothers_name}
            onChange={handleChange}
          />

          <LightTextField
            name="country"
            label="Country of Birth"
            sx={textInputStyles}
            value={formValues.country}
            error={!!formErrors.country}
            helperText={formErrors.country}
            onChange={handleChange}
          />
          <Select
            sx={selectedView}
            value={maritalStatus}
            onChange={handleMaritalStatus}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <H4 style={{ color: "#C0C0C0" }}>Marital Status</H4>;
              }
              return selected;
            }}
          >
            <MenuItem disabled value="">
              <H4>Marital Status</H4>
            </MenuItem>
            <MenuItem value={"MARRIED"}>MARRIED</MenuItem>
            <MenuItem value={"UNMARRIED"}>UNMARRIED</MenuItem>
          </Select>
          {maritalStatus === "MARRIED" && (
            <LightTextField
              name="spouse_name"
              label="Spouse Name"
              sx={textInputStyles}
              value={formValues.spouse_name}
              error={!!formErrors.spouse_name}
              helperText={formErrors.spouse_name}
              onChange={handleChange}
            />
          )}
          <Select
            sx={selectedView}
            value={occupationType}
            onChange={handleOccupationType}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <H4 style={{ color: "#C0C0C0" }}>Occupation Type</H4>;
              }
              if (
                selected === "AGRICULTURE" ||
                selected === "BUSINESS" ||
                selected === "DOCTOR" ||
                selected === "PROFESSIONAL" ||
                selected === "RETIRED" ||
                selected === "STUDENT" ||
                selected === "OTHERS"
              ) {
                return selected;
              }
              if (
                selected === "PUBLIC_SECTOR_SERVICE" ||
                selected === "PRIVATE_SECTOR_SERVICE"
              ) {
                const formattedValue = selected
                  .replace(/_/g, " ")
                  .replace(/_?SERVICE$/, "");
                return formattedValue;
              } else {
                const formattedValue = selected.replace(/_/g, " ");
                return formattedValue;
              }
            }}
          >
            <MenuItem disabled value="">
              <H4>Occupation Type</H4>
            </MenuItem>
            {OCCUPATION_PROOF_TYPE_LIST.map((item: any, index: any) => (
              <MenuItem key={index} value={item.value}>
                {item.key}
              </MenuItem>
            ))}
          </Select>

          <Select
            sx={selectedView}
            value={sourceWealth}
            onChange={handleSourceWealth}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <H4 style={{ color: "#C0C0C0" }}>Source of Wealth</H4>;
              }
              if (
                selected === "SALARY" ||
                selected === "BUSINESSMAN" ||
                selected === "GIFT" ||
                selected === "ROYALTY" ||
                selected === "OTHERS"
              ) {
                return selected;
              }
              if (selected === "ancestral property") {
                return "ANCESTRAL PROPERTY";
              } else {
                const formattedValue = selected.replace(/_/g, " ");
                return formattedValue;
              }
            }}
          >
            <MenuItem disabled value="">
              <H4>Source of Wealth</H4>
            </MenuItem>
            {WEALTH_TYPE_LIST.map((item, index) => (
              <MenuItem value={item.value}>{item.key}</MenuItem>
            ))}
          </Select>
          <LightTextField
            name="gross_income"
            label="Gross Income"
            sx={textInputStyles}
            value={formValues.gross_income}
            error={!!formErrors.gross_income}
            helperText={formErrors.gross_income}
            inputProps={{
              maxLength: grossIncomeLength,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            onChange={handleChange}
          />

          <LightTextField
            disabled
            name="residentalStatus"
            label="Residencial Status"
            sx={textInputStyles}
            value={"RESIDENT INDIVIDUAL"}
          />

          {complicePAN ? null : (
            <Select
              required
              sx={selectedView}
              value={proofType}
              onChange={handleAddressProoftype}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return (
                    <H4 style={{ color: "#C0C0C0" }}>Address Proof Type</H4>
                  );
                }
                if (selected === "PASSPORT") {
                  return selected;
                }
                if (selected === "driving_licence") {
                  return "DRIVING LICENCE";
                } else {
                  const formattedValue = selected.replace(/_/g, " ");
                  return formattedValue;
                }
              }}
            >
              <MenuItem disabled value="">
                <H4>Address Proof Type</H4>
              </MenuItem>
              {ADDRESS_PROOF_TYPE_LIST.map((item, index) => (
                <MenuItem value={item.value}>{item.key}</MenuItem>
              ))}
            </Select>
          )}

          {complicePAN ? null : (
            <LightTextField
              name="proof_number"
              label="Proof Number"
              sx={textInputStyles}
              value={formValues.proof_number ? formValues.proof_number : ""}
              error={!!formErrors.proof_number}
              helperText={formErrors.proof_number}
              onChange={handleChange}
            />
          )}

          {complicePAN ? null : (
            <TextField
              name="proof_issue_date"
              label="Proof Issued Date"
              type="date"
              inputProps={{
                min: minissueDate, // Set the minimum allowed date to a past date if desired
                max: maxissuesdate, // Set the maximum allowed date to today
              }}
              value={formValues.proof_issue_date}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={textInputStyles}
              error={!!formErrors.proof_issue_date}
              helperText={formErrors.proof_issue_date}
            />
          )}

          {complicePAN
            ? null
            : proofType !== "VOTER_ID" && (
                <TextField
                  name="proof_expiry_date"
                  label="Proof Expiry Date"
                  type="date"
                  inputProps={{
                    min: minexpiryDate, // Set the minimum allowed date
                    max: maxexpiryDate, // Set the maximum allowed date
                  }}
                  sx={textInputStyles}
                  value={formValues.proof_expiry_date}
                  error={!!formErrors.proof_expiry_date}
                  helperText={formErrors.proof_expiry_date}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}

          <FlexBox sx={radioContainer}>
            <Small fontSize={14} sx={genderText} color="#595959">
              Do you have residence outside india?
            </Small>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={radioValueResidence.toString()}
              onChange={handleChangeRadio}
              sx={{ marginTop: -1, marginLeft: 1 }}
            >
              <FormControlLabel
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "400",
                }}
                value={true.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value={false.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FlexBox>
          <FlexBox sx={radioContainer}>
            <Small fontSize={14} sx={genderText} color="#595959">
              Are you politically exposed person?
            </Small>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={radioValuePolitically.toString()}
              onChange={handleChangeradioValuePolitically}
              sx={{ marginTop: -1, marginLeft: 1 }}
            >
              <FormControlLabel
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "400",
                }}
                value={true.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value={false.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FlexBox>
          <FlexBox sx={radioContainer}>
            <Small fontSize={14} sx={genderText} color="#595959">
              Are you related politically exposed person?
            </Small>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={handleradioValueRelatedPolitically}
              value={radioValueRelatedPolitically.toString()}
              sx={{ marginTop: -1, marginLeft: 1 }}
            >
              <FormControlLabel
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: "400",
                }}
                value={true.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value={false.toString()}
                control={
                  <Radio
                    sx={{
                      color: "#FFF5D1",
                      "&.Mui-checked": {
                        color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                      },
                    }}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FlexBox>
          <Box sx={sxStyleBox1}>
            <Button
              onClick={() => onBackPress(formValues)}
              variant="contained"
              size="medium"
              sx={{
                mt: 3,
                mb: 2,
                py: 1,
                fontFamily: "'Poppins', sans-serif",
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "40%",
                },
                alignSelf: "center",
                background: "#FFF5D1",
                color: process.env.REACT_APP_PRIMARY_COLOR,
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
              }}
            >
              Back
            </Button>
            <Button
              type="submit"
              variant="contained"
              size="medium"
              sx={[buttonStyle, { textTransform: "none" }]}
            >
              Next
            </Button>
          </Box>
        </form>
      )}
    </>
  );
};

export default KYCSecondStep;
const headingText = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "48%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
  marginLeft: {
    xs: 0,
    sm: 0,
    md: 1.5,
  },
};
const buttonStyle = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "40%",
  },
  alignSelf: "center",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};

const radioContainer = {
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  mt: 2,
};
const selectedView = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "48%",
  },
  border: "0px solid",
  borderRadius: 2,
  borderColor: "#E8E8E8",
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
  marginLeft: {
    xs: 0,
    sm: 0,
    md: 1.5,
  },
  height: 55,
};
const sxStyleBox1 = {
  alignItems: "center",
  justifyContent: "space-around",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  display: "flex",
  mt: 2,
};
const genderText = {
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
